<template>
    <el-dialog :visible.sync="visible" title="Telegram Боты" :append-to-body="true" width="600px" v-loading="isLoading">
        <ul class="list-group list-group-flush">
            <li class="list-group-item">
                <span @click.prevent="visibleCreate = true" class="text-muted mt-2 cursor-pointer">Добавить бота</span>
            </li>
            <li class="list-group-item" v-for="bot in bots" :key="bot.id">
                <BotManageListItem :bot="bot" @updated="handlerUpdated" />
            </li>
        </ul>
        <el-dialog v-if="visibleCreate" :visible.sync="visibleCreate" @close="handlerCloseCreate" :title="'Добавление бота'" :append-to-body="true" width="400px">
            <BotForm @updated="handlerUpdated" />
        </el-dialog>
    </el-dialog>
</template>

<script>
import BotManageListItem from "./BotManageListItem.vue";
import BotForm from "./BotForm.vue";

export default {
    name: "BotsManage",
    components: {BotForm, BotManageListItem},
    data: () => ({
        visible: false,
        visibleCreate: false,
        isLoading: false,
        bots: [],
        errors: {},

        creating: {name: ""},
    }),
    mounted() {
        let self = this;
        this.$bus.$on('telegram_bots:open-manage', () => {
            self.visible = true;
        })
    },
    watch: {
        visible(v) {
            if (v) this.fetch();
        }
    },
    methods: {
        handlerUpdated() {
            this.fetch(false);
        },
        handlerCloseCreate() {
            this.fetch(false);
        },
        fetch(withLoader) {
            let self = this;
            if (withLoader) self.isLoading = true;
            axios.get('/api/telegram-bots')
                .then(res => {
                    self.bots = res.data;
                    self.isLoading = false;
                })
        },
        create(c) {
            let self = this;
            self.isLoading = true;
            axios.post('/api/agencies/', c)
                .then(res => {
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Добавлено',
                        duration: 2000,
                    });
                    self.creating = {name: ""}
                    self.fetch();
                })
                .catch(e => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка!',
                        duration: 2000,
                    });
                })
        }
    }
}
</script>

<style scoped>

</style>
